
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ProtocolType enum
 */
class ProtocolType {
  /**
   * Initialize enum with a given value
   * @param {ProtocolType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ProtocolType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ProtocolType}
   * @param {!ProtocolType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ProtocolType)) {
      throw new TypeError('Instance of ProtocolType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ProtocolType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ProtocolType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ProtocolType.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === ProtocolType.CLIENT.value) {
      return 'CLIENT'
    }
    if (this.value === ProtocolType.MANAGER.value) {
      return 'MANAGER'
    }
    if (this.value === ProtocolType.PUBLIC.value) {
      return 'PUBLIC'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ProtocolType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ProtocolType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ProtocolType} Created enum
   */
  static fromObject (other) {
    return new ProtocolType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ProtocolType.UNKNOWN = new ProtocolType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ProtocolType.CLIENT = new ProtocolType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
ProtocolType.MANAGER = new ProtocolType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
ProtocolType.PUBLIC = new ProtocolType(0 + 3)

export { ProtocolType };

/**
 * Fast Binary Encoding ProtocolType field model
 */
class FieldModelProtocolType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelProtocolType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelProtocolType}
   * @param {ProtocolType=} defaults Default value, defaults is new ProtocolType()
   * @returns {!ProtocolType} Result value
   */
  get (defaults = new ProtocolType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ProtocolType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelProtocolType}
   * @param {!ProtocolType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelProtocolType };
